export const firstCreateInfoWindow = function (foot) {
  var info = document.createElement("div");
  info.className = "custom-info input-card content-window-card";

  //可以通过下面的方式修改自定义窗体的宽高
  info.style.width = "220px";
  info.style.height = "150px";
  info.style.backgroundColor = "#fff";

  // 定义底部内容
  var bottom = document.createElement("div");
  bottom.className = "info-bottom";
  bottom.innerHTML = foot;
  info.appendChild(bottom);

  return info;
};

export const CreateEditAndDetail = function (foot) {
    var info = document.createElement("div");
    info.className = "custom-info editAndDetail-info";
  
    //可以通过下面的方式修改自定义窗体的宽高
    info.style.width = "220px";
    info.style.height = "150px";
    info.style.backgroundColor = "#fff";
  
    // 定义底部内容
    var bottom = document.createElement("div");
    bottom.className = "info-bottom";
    bottom.innerHTML = foot;
    info.appendChild(bottom);
  
    return info;
  };